import { GlassService } from './glassService.model';
import { ConfigService } from '@core/model/configService.model';
import { ModelInfo } from './modelInfo.model';

interface GlassType {
    TypeId: string;
    Description: string;
    RefRecId: bigint;
  }

interface GlassThickness {
    Thickness: string;
    RefRecId: bigint;
  }

interface GlassStyle {
    Style: string;
    SpecialSide: number;
    RefRecId: bigint;
  }

interface GlassColor {
    Color: string;
    RgbColor: string;
  }

export class GlassInfo extends ModelInfo {
    vAncho2: number;
    vAlto2: number;
    vDescuadrado: boolean;
    vLamina: boolean;
    vMedidaCorteLam: number;
    vCorteRapido: boolean;
    vPlantilla: boolean;
    vTipoVidrio: string;
    vTipoVidrioDesc: string;
    vEspesorVidrio: string;
    vEstiloVidrio: string;
    vAcabadoVidrio: string;
    GlassTypeList: GlassType[];
    GlassThicknessList: GlassThickness[];
    GlassStylesList: GlassStyle[];
    GlassColorList: GlassColor[];
    GlassServices: GlassService[];
    CutServices: GlassService[];
    vListaServicios: ConfigService[];
    vTemplado: boolean;
    vCornerTL: string;
    vCornerTR: string;
    vCornerBL: string;
    vCornerBR: string;
    vSideTop: string;
    vSideLeft: string;
    vSideRight: string;
    vSideBottom: string;
    vRouteModel: string;

    constructor() {
    super();
    this.vModelo = 'VIDRIO CORTADO';
    this.vCodArticulo = '0603401';
    this.vAncho2 = 0;
    this.vAlto2 = 0;
    this.vDescuadrado =  false;
    this.vLamina = false;
    this.vMedidaCorteLam = 0;
    this.vCorteRapido = false;
    this.vPlantilla = false;
    this.vTipoVidrio = '';
    this.vTipoVidrioDesc = '';
    this.vEspesorVidrio = '';
    this.vEstiloVidrio = '';
    this.vAcabadoVidrio = '';
    this.GlassTypeList = [];
    this.GlassThicknessList = [];
    this.GlassStylesList = [];
    this.GlassColorList = [];
    this.GlassServices = [];
    this.CutServices = [];
    this.vListaServicios = [];
    this.vTemplado = false;
    this.vCornerTL = '';
    this.vCornerTR = '';
    this.vCornerBL = '';
    this.vCornerBR = '';
    this.vSideTop = '';
    this.vSideLeft = '';
    this.vSideRight = '';
    this.vSideBottom = '';
    }

    redimensionarModelo() {
      this.vListaServicios.forEach(ServicioTmp => {
        if (ServicioTmp.vNaturaleza === 1 || ServicioTmp.vNaturaleza === 3) {
          if (ServicioTmp.vAncho1 !== 0) {
            ServicioTmp.vAncho1 = this.vAncho1;
          }
          if (ServicioTmp.vAlto1 !== 0) {
            ServicioTmp.vAlto1 = this.vAlto1;
          }
          if (ServicioTmp.vAncho2 !== 0) {
            ServicioTmp.vAncho2 = this.vAncho2;
          }
          if (ServicioTmp.vAlto2 !== 0) {
            ServicioTmp.vAlto2 = this.vAlto2;
          }
        } else if (ServicioTmp.vNaturaleza === 2) {
          if (this.vAncho1 > this.vAncho2) {
            ServicioTmp.vAncho1 = this.vAncho1;
          } else {
            ServicioTmp.vAncho1 = this.vAncho2;
          }
          if (this.vAlto1 > this.vAlto2) {
            ServicioTmp.vAlto1 = this.vAlto1;
          } else {
            ServicioTmp.vAlto1 = this.vAlto2;
          }
        }
      });
    }

    duplicarModelo() {
      let newModel = new GlassInfo();

      newModel.vModelo = this.vModelo;
      newModel.vCodArticulo = this.vCodArticulo;
      newModel.vAncho1 = this.vAncho1;
      newModel.vAlto1 = this.vAlto1;
      newModel.vDescuadrado = this.vDescuadrado;
      newModel.vLamina = this.vLamina;
      newModel.vMedidaCorteLam = this.vMedidaCorteLam;
      newModel.vCorteRapido = this.vCorteRapido;
      newModel.vPlantilla = this.vPlantilla;
      newModel.vTipoVidrio = this.vTipoVidrio;
      newModel.vTipoVidrioDesc = this.vTipoVidrioDesc;
      newModel.vEspesorVidrio = this.vEspesorVidrio;
      newModel.vEstiloVidrio = this.vEstiloVidrio;
      newModel.GlassTypeList = this.GlassTypeList;
      newModel.GlassThicknessList = this.GlassThicknessList;
      newModel.GlassStylesList = this.GlassStylesList;
      newModel.GlassColorList = this.GlassColorList;
      newModel.GlassServices = this.GlassServices;
      newModel.CutServices = this.CutServices;
      newModel.vListaServicios = this.vListaServicios;//OJO
      newModel.vTemplado = this.vTemplado;
      newModel.vCornerTR = this.vCornerTR;
      newModel.vCornerBL = this.vCornerBL;
      newModel.vCornerBR = this.vCornerBR;
      newModel.vSideTop = this.vSideTop;
      newModel.vSideLeft = this.vSideLeft;
      newModel.vSideRight = this.vSideRight;
      newModel.vSideBottom = this.vSideBottom;

      newModel.vAncho2 = this.vAncho2;
      newModel.vAlto2 = this.vAlto2;
      newModel.vCantidad = this.vCantidad;
      newModel.vMoneda = this.vMoneda;
      newModel.vPrecio = this.vPrecio;
      newModel.vDescuento = this.vDescuento;
      newModel.vPorcDesc = this.vPorcDesc;
      newModel.vUnidad = this.vUnidad;
      newModel.shoppingCartItemId = this.shoppingCartItemId;
      newModel.vImagen = this.vImagen;
      newModel.vTipoProduccion = this.vTipoProduccion;
      newModel.vEspMinCapa = this.vEspMinCapa;
      newModel.vEspMaxCapa = this.vEspMaxCapa;
      newModel.vEspMin = this.vEspMin;
      newModel.vEspMax = this.vEspMax;
      newModel.vSitio = this.vSitio;
      newModel.vCliente = this.vCliente;
      newModel.vProyecto = this.vProyecto;
      newModel.vModeloPadre = this.vModeloPadre;
      newModel.vRouteModel = this.vRouteModel;

      return newModel;
    }
}
